import queryString from 'query-string';
import { ENDPOINTS } from 'config/endpoints';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import CronoError from 'crono-fe-common/types/error';
import client from 'utils/clients/client';
import { Request } from 'crono-fe-common/types/request';
import { Response } from 'crono-fe-common/types/response';
import { invalidateTimelineQueries } from 'hooks/services/timeline/useSearchTimeline';

export default function useDeleteStrategy() {
  const queryClient = useQueryClient();

  const deleteStrategy = (strategyId: number) => {
    const queryParams = queryString.stringify({ strategyId });

    const request: Request = {
      url: `${ENDPOINTS.strategy.main}?${queryParams}`,
      config: {
        method: 'delete',
      },
    };
    return client(request);
  };

  const { data, mutate, ...rest } = useMutation<
    Response<null>,
    CronoError,
    number
  >(deleteStrategy, {
    onSettled: () => {
      queryClient.invalidateQueries([ENDPOINTS.strategy.main]);
      queryClient.invalidateQueries([ENDPOINTS.strategy.search]);
      queryClient.invalidateQueries([ENDPOINTS.task.aggregate]);
      queryClient.invalidateQueries([ENDPOINTS.task.search]);
      invalidateTimelineQueries(queryClient);
      queryClient.invalidateQueries([ENDPOINTS.task.main]);
      queryClient.invalidateQueries([ENDPOINTS.task.user.analytics]);

      queryClient.invalidateQueries([ENDPOINTS.task.total]);
      queryClient.invalidateQueries([ENDPOINTS.task.dailyQuantity]);
    },
  });

  return { data, mutate, ...rest };
}
